/* eslint-disable */
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Box, Dialog, DialogContent, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button, Col, Form, Input, Row } from 'antd';
import InputLabel from 'components/InputLabel/index';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import { toastConfig } from 'config';
import ConfirmModal from 'components/modal/ConfirmModal';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import { decodeQueryParamData } from 'utils/utils';
import useGetStateFromParams from 'static-solutions/hook/useGetStateFromParams';

const DetailInput = ({ label, value }) => (
	<Box sx={{ mb: 2.5 }}>
		<Box sx={{ mb: 0.75, fontSize: '14px', fontWeight: 600, color: '#2E2E2E' }}>{label}</Box>
		<Input
			disabled
			value={value ?? '-'}
			style={{
				height: 38,
				borderRadius: 8,
				color: '#5F5F5F',
				backgroundColor: '#FAFAFA',
				borderColor: '#D0D0D0',
				cursor: 'default',
			}}
		/>
	</Box>
);

function DetailsModal({ item: id, setItem, data, showModal, handleClose, setRerender }) {
	const [form] = Form.useForm();

	const [sendControlData, { isLoading, isSuccess, isError }] = useSendControlDataMutation();

	const theme = useTheme();
	// const { state } = useLocation();
	const { state } = useGetStateFromParams();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const [singleData, setSingleData] = useState(null);
	const [payload, setPayload] = useState(null);
	const [confirmModal, setConfirmModal] = useState(false);
	const [pagination, setPagination] = useState({
		currentPage: 0,
		firstPage: 0,
		lastPage: 0,
	});
	const [screenSize, setScreenSize] = useState('md');

	// console.log('state', state);

	const handleSubmit = (submittedData) => {
		const refinedSubmittedData = {
			id: submittedData.id,
			actionType: 'submit',

			rootCause: submittedData.rootCause ?? '',
			impact: submittedData.impact ?? '',
			finding: submittedData.finding ?? '',
			// impactDetails: submittedData.impactDetails ?? '',
			recommendation: submittedData.recommendation ?? '',
			ownerFeedback: submittedData.ownerFeedback ?? '',
			agreedResolutionTime: submittedData.agreedResolutionTime ?? '',
			rating: submittedData.rating ?? '',
			evidenceAttachment: submittedData.evidenceAttachment ?? '',
			testingEvidence: submittedData.testingEvidence ?? '',
			samplingMethod: submittedData.samplingMethod ?? '',
			sampleSize: submittedData.sampleSize ?? '',
			populationSize: submittedData.populationSize ?? '',
		};

		// console.log(refinedSubmittedData);

		const convertJson = JSON.stringify(refinedSubmittedData);
		const convertBase64 = btoa(convertJson);

		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitTesting',
		});

		setConfirmModal(true);
	};

	const handleAction = (action) => {
		const refinedSubmittedData = {
			id,
			action,
		};
		const convertJson = JSON.stringify(refinedSubmittedData);
		const convertBase64 = btoa(convertJson);
		// console.log('🚀 ~ handleAction ~ convertBase64:', convertBase64);

		setPayload({
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'submitAnswer',
		});
		setConfirmModal(true);
	};

	const currentUserIdentity = (id, data) => {
		// const currentItem = data.find((item) => item.id === id);
		// console.log('singleData-----', singleData);
		if (
			singleData?.testerUserId === userId &&
			(singleData.testingStatus.toLowerCase() === 'testing pending' || singleData.testingStatus.toLowerCase() === 'testing rejected')
		) {
			return 'AccessToSubmit';
		} else return 'AccessToView';
	};

	const onModalOkHandler = () => {
		if (payload) {
			sendControlData(payload);
		}
	};

	// const actualChangeHandler = (e) => {
	// 	const expectation = singleData?.expectation.toLowerCase();
	// 	const remark = e.target.value.toLowerCase();

	// 	setActualValue(e.target.value?.toLowerCase());

	// 	if (remark?.length < 1) return;
	// 	else if (expectation === remark) setRemarkVisible(false);
	// 	else setRemarkVisible(true);
	// };

	const onPreHandler = () => {
		if (pagination.currentPage > 0) {
			const prevPageIndex = pagination.currentPage - 1;
			if (prevPageIndex > -1 && pagination.lastPage) {
				setSingleData(data[prevPageIndex]);
				setItem(data[prevPageIndex].id);
			} else setSingleData(null);

			setPagination((prev) => ({
				...prev,
				currentPage: prevPageIndex,
			}));
		}
	};

	const onNextHandler = () => {
		if (pagination.currentPage < pagination.lastPage) {
			const nextPageIndex = pagination.currentPage + 1;
			if (nextPageIndex > -1 && pagination.lastPage) {
				setSingleData(data[nextPageIndex]);
				setItem(data[nextPageIndex].id);
			} else setSingleData(null);

			setPagination((prev) => ({
				...prev,
				currentPage: nextPageIndex,
			}));
		}
	};

	useEffect(() => {
		if (isSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			// form.resetFields();
			setRerender((prev) => prev + 1);
			handleClose();
			setPayload(null);
		} else if (isError) {
			toast.error('Failed! Action not completed', toastConfig);
			// form.resetFields();
			setPayload(null);
		}
	}, [isSuccess, isError]);

	useEffect(() => {
		// console.log('------------', data);

		if (data?.length > 0 && id) {
			const currentItemIndex = data?.findIndex((item) => item.id === id);
			if (currentItemIndex > -1) setSingleData(data[currentItemIndex]);
			setPagination({
				currentPage: currentItemIndex,
				firstPage: 0,
				lastPage: data?.length - 1,
			});
		}
	}, []);

	const detailFields = [
		{ label: 'Budget Code', value: singleData?.budgetCode },
		{ label: 'Year', value: singleData?.budgetYear },
		{ label: 'Case No', value: singleData?.lynUniqueId },
		{ label: 'Initial Plan', value: singleData?.budgetAmount },
		{ label: 'Transfers', value: singleData?.transferredOutAmount },
		{ label: 'Unapproved Transfers', value: singleData?.transferReservedAmount },
		{ label: 'Current Plan', value: singleData?.adjustedAmount },
		{ label: 'Unapproved Budget Release', value: singleData?.reservedAmount },
		{ label: 'Approved Budget Release', value: singleData?.consumedAmount },
		{ label: 'Unavailable Budget', value: singleData?.unavailableAmount },
		{ label: 'Current Available Budget', value: singleData?.freeAmount },
		{ label: 'Projected Plan', value: singleData?.projectedAdjustedAmount },
		{ label: 'Budget Held Up', value: singleData?.heldAmount },
		{ label: 'Projected Available Budget', value: singleData?.projectedFreeAmount },
	];

	return (
		<>
			<Dialog
				fullWidth={true}
				open={showModal}
				aria-labelledby="announcement-modal"
				sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
				fullScreen={screenSize === 'full' ? true : false}
				maxWidth={screenSize}
			>
				<ViewEditModalHeader
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
					viewType={false}
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
					headerTitle={'View Control Testing'}
				/>

				<DialogContent>
					{singleData === null ? (
						<Box>Loading...</Box>
					) : (
						<Form form={form} layout="vertical" requiredMark={false} validateTrigger={['onChange', 'onBlur']} onFinish={handleSubmit}>
							<Form.Item noStyle name="id" initialValue={singleData?.id} />

							<Row gutter={[24, 0]}>
								{detailFields.map((field) => (
									<Col key={field.label} xs={24} md={12}>
										<DetailInput label={field.label} value={field.value} />
									</Col>
								))}
							</Row>

							{/*
							Old field layout:
							<Row gutter={[16, 0]}>
								<Col xs={24} md={6}><InputLabel label="Budget Code" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.budgetCode} /></Col>
								<Col xs={24} md={6}><InputLabel label="Year" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.budgetYear} /></Col>
								<Col xs={24} md={6}><InputLabel label="Case No" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.lynUniqueId} /></Col>
								<Col xs={24} md={6}><InputLabel label="Initial Plan" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.budgetAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Transfers" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.transferredOutAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Unapproved Transfers" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.transferReservedAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Current Plan" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.adjustedAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Unapproved Budget Release" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.reservedAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Approved Budget Release" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.consumedAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Unavailable Budget" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.unavailableAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Current Available Budget" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.freeAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Projected Plan" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.projectedAdjustedAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Budget Held Up" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.heldAmount} /></Col>
								<Col xs={24} md={6}><InputLabel label="Projected Available Budget" head={true} /></Col>
								<Col xs={24} md={6}><InputLabel label={singleData?.projectedFreeAmount} /></Col>
							</Row>
							*/}

							<Row>
								<Col xs={24}>
									<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
										<Box>
											<>
												{/* {currentUserIdentity(id, data) === 'LoginAsOwner' && (
													<>
														<MuiButton
															type="button"
															htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: 'rgb(3, 57, 108)',
																color: 'common.white',
																width: '6rem',
																'&:hover': { bgcolor: 'rgb(3, 57, 108)' },
															}}
															onClick={() => handleAction('approve')}
														>
															Approve
														</MuiButton>
														<MuiButton
															type="button"
															// htmlType="submit"
															disabled={false}
															variant="contained"
															sx={{
																fontSize: '13px',
																fontWeight: '500',
																borderRadius: '6px',
																marginLeft: '6px',
																padding: '4px 0',
																bgcolor: theme.palette.lynTheme.delete,
																color: 'common.white',
																width: '7rem',
																'&:hover': { bgcolor: theme.palette.lynTheme.delete },
															}}
															onClick={() => handleAction('reject')}
														>
															Reject
														</MuiButton>
													</>
												)} */}

												{currentUserIdentity(id, data) === 'AccessToSubmit' && (
													<Button type="primary" htmlType="submit" disabled={isLoading}>
														Submit
													</Button>
												)}
											</>
										</Box>

										<Stack direction="row" justifyContent="right" sx={{ mb: 2, gap: '5px' }}>
											<Button onClick={onPreHandler} disabled={pagination?.currentPage < 1}>
												<CaretLeftOutlined />
											</Button>

											<Button onClick={onNextHandler} disabled={pagination?.currentPage >= pagination?.lastPage}>
												<CaretRightOutlined />
											</Button>
										</Stack>
									</Stack>
								</Col>
							</Row>
						</Form>
					)}
				</DialogContent>
			</Dialog>

			{confirmModal && (
				<ConfirmModal
					icon={false}
					modalData={{ head: 'Confirmation' }}
					showModal={confirmModal}
					setShowModal={setConfirmModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</>
	);
}

export default DetailsModal;
